<template>
  <div class="tacticsBox">
    <el-row style="background: #ffffff;" class="shadow">
      <h3 class="tactics">组合收益</h3>
      <el-col :span="10">
        <ul class="UlTOP">
          <!-- {{getData.AT3Trend.AT3BasicInfo}} -->
          <li v-if="sCombinPerm.dbAccumulateYield">
            <h4>累计收益</h4>
            <h3
              :class="sCombinPerm.dbAccumulateYield>0?'pgUp':'pgDn'"
            >{{(sCombinPerm.dbAccumulateYield*100).toFixed(2)}}%</h3>
          </li>
          <li>
            <span>组合主动年化收益</span>
            <span
              class="fr"
              :class="(sCombinPerm.dbActiveAnnualYield*100).toFixed(2)<0?'pgDn':'pgUp'"
            >{{(sCombinPerm.dbActiveAnnualYield*100).toFixed(2)}}%</span>
          </li>
          <li>
            <span>单边年化换手率</span>
            <span
              class="fr"
              :class="(sCombinPerm.dbAnnualTurnOverRate*100).toFixed(2)<0?'pgDn':'pgUp'"
            >{{(sCombinPerm.dbAnnualTurnOverRate*100).toFixed(2)}}%</span>
          </li>
          <li>
            <span>信息比率（IR）</span>
            <span
              class="fr"
              :class="sCombinPerm.dbIR>0?'pgUp':'pgDn'"
            >{{Number(sCombinPerm.dbIR*100).toFixed(2)}}%</span>
          </li>
          <li>
            <span>IC均值</span>
            <span
              class="fr"
              :class="sCombinPerm.dbIC>0?'pgUp':'pgDn'"
            >{{Number(sCombinPerm.dbIC).toFixed(4)}}</span>
          </li>
          <li>
            <span>标的</span>
            <span class="fr" v-if="sParam.sTargetIdxPlate">{{sParam.sTargetIdxPlate.wstrName}}</span>
          </li>
          <li>
            <span>基准</span>
            <span class="fr" v-if="sParam.sBenchMark">{{sParam.sBenchMark.wstrName}}</span>
          </li>
          <li>
            <span>起始时间</span>
            <span class="fr">{{sParam.dtBegin}}</span>
          </li>
          <li>
            <span>终止时间</span>
            <span class="fr">{{sParam.dtEnd}}</span>
          </li>
        </ul>
      </el-col>
      <el-col :span="14">
        <div style="width: 100%;height:430px;">
          <tracharts :startID="'lossData'" :kechartsData="lossData" :types="true" ref="lossData"></tracharts>
        </div>
      </el-col>
    </el-row>
    <el-row style="background: #ffffff;margin-top:20px;" class="shadow">
      <h3 class="tactics">因子收益</h3>
      <el-col :span="10">
        <ul class="UlTOP">
          <!-- {{getData.AT3Trend.AT3BasicInfo}} -->
          <li v-if="sFactorPerm.dbAccumulateYield">
            <h4>累计收益</h4>
            <h3
              :class="sFactorPerm.dbAccumulateYield>0?'pgUp':'pgDn'"
            >{{(sFactorPerm.dbAccumulateYield*100).toFixed(2)}}%</h3>
          </li>
          <li>
            <span>信息比率（IR）</span>
            <span
              class="fr"
              :class="sFactorPerm.dbIR>0?'pgUp':'pgDn'"
            >{{Number(sFactorPerm.dbIR*100).toFixed(2)}}%</span>
          </li>
          <li>
            <span>IC均值</span>
            <span
              class="fr"
              :class="sFactorPerm.dbIC>0?'pgUp':'pgDn'"
            >{{Number(sFactorPerm.dbIC).toFixed(4)}}</span>
          </li>
          <li>
            <span>标的</span>
            <span class="fr" v-if="sParam.sTargetIdxPlate">{{sParam.sTargetIdxPlate.wstrName}}</span>
          </li>
          <li>
            <span>基准</span>
            <span class="fr" v-if="sParam.sBenchMark">{{sParam.sBenchMark.wstrName}}</span>
          </li>
          <li>
            <span>起始时间</span>
            <span class="fr">{{sParam.dtBegin}}</span>
          </li>
          <li>
            <span>终止时间</span>
            <span class="fr">{{sParam.dtEnd}}</span>
          </li>
        </ul>
      </el-col>
      <el-col :span="14">
        <div style="width: 100%;height:430px;">
          <tracharts :startID="'lossData1'" :kechartsData="sFactor" :types="false" ref="lossData1"></tracharts>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// common/kecharts
import tracharts from "./common/tracharts";
// import kecharts from "../../strategy/common/kecharts";
export default {
  components: { tracharts },
  props: {
    getData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lossData: {
        dataValue: [],
        tiem: []
      },
      sCombinPerm: {},
      sFactorPerm: {},
      sParam: {},
      sFactor: {} // 因子收益
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      this.lossData = {
        dataValue: [],
        tiem: []
      };
      this.sCombinPerm = JSON.parse(JSON.stringify(this.getData.sCombinPerm));
      this.sFactorPerm = JSON.parse(JSON.stringify(this.getData.sFactorPerm));
      this.sParam = JSON.parse(JSON.stringify(this.getData.sParam));
      this.lossData.dataValue.push(
        {
          value: this.getData.listCombinYield,
          name: "组合收益率"
        },
        {
          value: this.getData.listBenchMarkYield,
          name: "基准收益率"
        }
      );
      this.lossData.tiem = this.getData.listTimeLine;
      // 因子收益
      this.sFactor = {
        tiem: this.getData.listTimeLine,
        name: "因子收益率",
        value: this.getData.listFactorYield
      };
      this.$nextTick(() => {
        this.$refs.lossData.echartsInit();
        this.$refs.lossData1.echartsInit();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tacticsBox {
  .tactics {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    height: 42px;
    line-height: 42px;
    background: rgba(240, 242, 245, 1);
    box-shadow: 0px 0px 8px 0px rgba(239, 242, 255, 1);
    text-shadow: 0px 0px 4px rgba(214, 234, 255, 1);
    padding-left: 10px;
  }
  .UlTOP {
    margin: 34px 0px 33px 48px;
    li:first-child {
      height: 110px;
    }
    li {
      color: #666666;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      border-bottom: 1px solid #dddddd;
      height: 32px;
      line-height: 32px;
      h4 {
        color: #666666;
        font-size: 12px;
        font-weight: bold;
      }
      h3 {
        font-size: 35px;
        font-weight: 400;
        line-height: 50px;
      }
    }
    .ulRed {
      color: #ff5454;
    }
    .ulBule {
      color: #1482f1;
    }
  }
  .pgUp {
    color: #f15a5a;
  }
  .pgDn {
    color: #1bb10a;
  }
  .tacticsUl {
    margin: 0 14px;
    li {
      color: #666666;
      display: inline-block;
      width: 20%;
      text-align: center;
      p:nth-child(1) {
        margin: 18px 0;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
      }
    }
  }
  .shadow {
    box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
  }
}
</style>
